import {
    REQUEST_BROKERAGES,
    RECEIVE_BROKERAGES,
    ERROR_BROKERAGES
} from '../types'
import {initialFetchState} from "../../constants/defaultValues"
import _get from "lodash/get"
import _cloneDeep from 'lodash/cloneDeep'

export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_BROKERAGES:
            newState[action.identifier] = {
                ...initialFetchState,
                data: _get(newState, [action.identifier, 'data'], {}),
                isFetching: true
            }
            return newState
        case RECEIVE_BROKERAGES:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: action.payload,
                message: '',
                errors: {}
            }
            return newState
        case ERROR_BROKERAGES:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: {},
                message: action.errors.server || '',
                errors: action.errors
            }
            return newState
        default:
            return state
    }
}